import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Download } from "react-bootstrap-icons";

const PropertySection = ({
  formData,
  formErrors,
  onInputChange,
  setToastMessage,
  setToastVariant,
  setShowToast,
  autoFillLoading,
  handleManualAutoFill,
  handleAutoAutoFill,
}) => {
  const handleAutoFillClick = () => {
    handleManualAutoFill(
      formData,
      setToastMessage,
      setToastVariant,
      setShowToast,
      onInputChange
    );
  };

  return (
    <div className="appointment-section">
      <div className="section-header">
        <h6 className="section-title">Property Details</h6>
        <Button
          variant="outline-primary"
          size="sm"
          className="auto-fill-btn"
          onClick={handleAutoFillClick}
          disabled={autoFillLoading}
        >
          <Download size={14} className="me-1" />
          {autoFillLoading ? "Loading..." : "Auto-Fill"}
        </Button>
      </div>
      <div className="section-fields">
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Year Built</Form.Label>
              <Form.Control
                type="number"
                value={formData.year_build}
                onChange={(e) => onInputChange("year_build", e.target.value)}
                isInvalid={!!formErrors.year_build}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.year_build}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Square Feet</Form.Label>
              <Form.Control
                type="number"
                value={formData.floor_area}
                onChange={(e) => onInputChange("floor_area", e.target.value)}
                isInvalid={!!formErrors.floor_area}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.floor_area}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Number of Stories</Form.Label>
              <Form.Control
                type="number"
                value={formData.stories}
                onChange={(e) => onInputChange("stories", e.target.value)}
                isInvalid={!!formErrors.stories}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.stories}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>House Type</Form.Label>
              <Form.Select
                value={formData.house_type}
                onChange={(e) => onInputChange("house_type", e.target.value)}
                isInvalid={!!formErrors.house_type}
              >
                <option value="">Select House Type</option>
                <option value="SINGLE_FAMILY">Single Family</option>
                <option value="TOWNHOUSE">Townhouse</option>
                <option value="MULTI_FAMILY">Multi-Family</option>
                <option value="CONDO">Condo</option>
                <option value="LOT">Lot</option>
                <option value="APARTMENT">Apartment</option>
                <option value="MANUFACTURED">Manufactured</option>
                {/* <option value="UNKNOWN">Other</option> */}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {formErrors.house_type}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Parcel Number</Form.Label>
              <Form.Control
                type="text"
                value={formData.apn}
                onChange={(e) => onInputChange("apn", e.target.value)}
                isInvalid={!!formErrors.apn}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.apn}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Note</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={formData.info}
                onChange={(e) => onInputChange("info", e.target.value)}
                isInvalid={!!formErrors.info}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.info}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PropertySection;
